import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import CollasableItem from './CollapsibleItem';
import { VisibleContentWrapper, BoxscoreIconWrapper } from '../BoxscoreInfo.style';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import COLORS from '@mlb/react-patterns/v4/style/universal.color.ts';
import { AccordionIconTypeTypes, AccordionIconThemeTypes } from '@mlb/react-patterns/v4/components/AccordionItem/AccordionItem.types';
const { mlbGrey5 } = COLORS;
const iconWidth = 10.2;
const Collapsible = ({
    visibleContent,
    collapsibleContent,
    showButton,
    toggleState = false,
    expandedFromTop = false,
    handlers = {}
}) => {
    const [expanded, setExpanded] = useState(toggleState);
    const enableSyncing = !!(handlers && handlers.onClick);
    const onClick = () => {
        const newState = !expanded;
        setExpanded(newState);

        if (enableSyncing) {
            handlers.onClick(newState);
        }
    };

    const expandedState = enableSyncing ? expandedFromTop : expanded;
    const renderVisible = (
        <Fragment>
            {
                showButton &&
                <BoxscoreIconWrapper
                    iconType={ AccordionIconTypeTypes.CIRCULAR }
                    iconTheme={ AccordionIconThemeTypes.LIGHT }
                    iconRotated={expandedState}
                    onClick={onClick}
                >
                    <Icon name='arrow-expand' fill={mlbGrey5} width={iconWidth}/>
                </BoxscoreIconWrapper>
            }
            <VisibleContentWrapper>{visibleContent}</VisibleContentWrapper>
        </Fragment>
    );

    const collapsibleItemProps = {
        renderVisible,
        expanded: expandedState,
        collapsible: collapsibleContent
    };

    return (
        <CollasableItem {...collapsibleItemProps} />
    );
};

Collapsible.propTypes = {
    collapsibleContent: PropTypes.element,
    visibleContent: PropTypes.element,
    showButton: PropTypes.bool,
    toggleState: PropTypes.bool,
    expandedFromTop: PropTypes.bool,
    handlers: PropTypes.object
};

export default Collapsible;
